import { Injectable } from '@angular/core';
import {Subject} from "rxjs";


@Injectable({
  providedIn: 'root',
})
export class DataService {
  public currentIp = new Subject<string>();

  constructor() {
    //This is intentional
  }

  public setCurrentIp(title: string) {
    this.currentIp.next(title);
  }

}
